import React, { useEffect, useState } from "react";
import Button from "../../../../components/common/ui/Button";
import Table from "../../../../components/common/table/Table";
import {
  FileInput,
  RadioInput,
  SelectInput,
  TextInput,
} from "../../../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { documentsActions } from "../../../../_store/documents.slice";
import { categoryActions } from "../../../../_store/category.slice";
import { useLocation } from "react-router-dom";
import { committeeActions } from "../../../../_store/committee.slice";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import CommitteeDocumentPageSchema from "../../../../validation/Admin/CommitteeDocumentPageSchema";
import ToggleSwitch from "../../../../components/common/ui/Inputs/ToggleSwitch";
import editIcon from "../../../../assets/svg/edit-icon.svg";
import deleteIcon from "../../../../assets/svg/delete-icon.svg";
import view from "../../../../assets/svg/view-document.svg";
import CustomLoader from "../../../../components/common/ui/Loader";
import { Popup } from "../../../../components/common/ui/NotificationModal/Popup";
import { history } from "../../../../_helpers";
import Swal from "sweetalert2";
import CommonModal from "../../../../components/common/ui/NotificationModal/CommonModal";
import { Modal } from "bootstrap";
import categorySchema from "../../../../validation/Admin/CategorySchema";

function CommitteeDocumentPage() {
  const { documentForm, AlldocList, loading } = useSelector((x) => x.documents);
  const { getAllActiveUsersResponse } = useSelector((x) => x?.master);
  const { CategoryDropdownlist } = useSelector((x) => x.category);

  const dispatch = useDispatch();

  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);

  const [apiParams, setApiParams] = useState(
    `&page=${1}&limit=${10}&status=${true}`,
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);

  const location = useLocation();
  const committeeId = location?.state?.committee?._id;
  const committeeName = location?.state?.committee?.committeeName;

  const [editRow, setEditRow] = useState({});
  const [createDoc, setCreateDoc] = useState(false);

  const totalCount = AlldocList?.totalItems || 0;

  const [updateFileName, setUpdateFileName] = useState("");
  const URL = updateFileName.split("/");
  const title = URL?.[URL?.length - 1];

  const { ActiveStatus } = useSelector((x) => x?.dropDown);

  const [Filters, SetFilters] = useState({
    title: "",
    category: "",
    status: true,
  });

  useEffect(() => {
    const resetHandler = () => {
      setIsEditMode(false);
      setCreateDoc(false);
    };

    window.addEventListener("resetDocumentPage", resetHandler);
    return () => {
      window.removeEventListener("resetDocumentPage", resetHandler);
    };
  }, []);

  useEffect(() => {
    const query = new URLSearchParams({
      page: "1",
      limit: "10",
      ...Object.fromEntries(
        Object.entries(Filters).filter(([_, v]) => v !== ""),
      ),
    }).toString();

    setApiParams(`&${query}`);
  }, [Filters]);

  useEffect(() => {
    dispatch(documentsActions.resetDocumentForm());
  }, []);
  useEffect(() => {
    if (!committeeId) return;
    dispatch(documentsActions.getAllDocuments(committeeId));
    dispatch(categoryActions.getCategoryLabel(committeeId));
  }, [committeeId]);

  useEffect(() => {
    Swal.close();
  }, []);

  const allowedMimeTypes = [
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "image/jpeg",
    "image/png",
    "image/webp",
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  ];

  const handleChange = (e, name) => {
    const data = { ...documentForm };

    const value = e?.target?.value;
    if (name === "file") {
      const file = e.target.files?.[0];
      setUpdateFileName("");

      if (file) {
        if (allowedMimeTypes.includes(file.type)) {
          data.file = file;
          data.fileCheck = { name: file.name, type: file.type || "" };
        } else {
          showToastNotification("Unsupported Media Type", "error");
          data.file = undefined;
          data.fileCheck = undefined;
          e.target.value = ""; // reset input field
          return;
        }
      } else {
        data.file = undefined;
        data.fileCheck = undefined;
      }
    } else if (name === "title") {
      const regex = /^[A-Za-z0-9 _@#%&'-]*$/;
      if (!regex.test(value)) {
        return;
      }
      data.title = e.target.value;
    } else if (name === "category") {
      data.category = e?.value; // because it's an object like { label, value }
    }

    dispatch(documentsActions.updateDocumentForm(data));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    setIsPending(true);
    setErrorMessage({});
    setUpdateFileName("");
    const { error } = CommitteeDocumentPageSchema(documentForm);

    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    const formData = new FormData();
    formData.append("title", documentForm?.title);
    formData.append("committee", committeeId);
    formData.append("category", documentForm?.category);
    formData.append("file", documentForm?.file);

    const request = isEditMode
      ? dispatch(
          documentsActions.UpdateDocument({
            id: editRow?.id, // pass id separately
            body: formData, // send form data separately
          }),
        )
      : dispatch(
          documentsActions.CreateDocument({
            id: committeeId, // pass id separately
            body: formData, // send form data separately
          }),
        );

    request
      .then((result) => {
        setIsPending(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          setEditRow({});
          setIsEditMode(false);
          setCreateDoc(false);
          dispatch(documentsActions.getAllDocuments(committeeId));
          dispatch(documentsActions.resetDocumentForm());
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setIsPending(false);
      });
  };

  const handleFormReset = () => {
    const params = `?page=${1}&limit=${10}&status=${true}`;
    setApiParams(params);
    if (isEditMode) {
      setErrorMessage({});
      setUpdateFileName(editRow?.file);
      dispatch(documentsActions.updateDocumentForm(editRow));
      return;
    }
    setErrorMessage({});
    dispatch(documentsActions.resetDocumentForm());
    dispatch(categoryActions?.resetCategoryForm());
  };

  const columns = [
    {
      name: "File Name",
      key: "title",
      selector: (row) => row.title || "N/A",
      sortable: true,
    },
    {
      name: "Category",
      key: "category",
      selector: (row) => row.category?.title || "N/A", // ✅ FIX
      sortable: true,
    },
    {
      name: "Created By",
      key: "createdBy",
      selector: (row) =>
        // `${row.createdBy?.firstName || ""} ${row.createdBy?.lastName || ""}`,
        `${row.createdBy?.fullName || ""}`, // ✅ FIX
      sortable: true,
    },
    {
      name: "Created At",
      key: "createdAt",
      selector: (row) =>
        // new Date(row.createdAt).toLocaleDateString("en-GB", {
        //   day: "2-digit",
        //   month: "short",
        //   year: "numeric",
        // }),
        new Date(row.createdAt).toLocaleDateString("en-US", {
          month: "short", // Sep
          day: "2-digit", // 18
          year: "numeric", // 2025
        }),
      sortable: true,
    },
    {
      // width: "120px",
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={view}
            title="Reviewed By"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              reviewDocument(row);
            }}
          />
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              editDocument(row);
            }}
          />

          <img
            src={deleteIcon}
            title="Delete"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleDelete(row);
            }}
          />
          <ToggleSwitch
            name={`status${row._id}`}
            id={`status${row._id}`}
            checked={row.status === true}
            value={row.status === true ? 1 : 0}
            handleClick={(e) => handleDocumentStatus(e, row)}
            title="Status"
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const [documentsReviewed, setDocumentsReviewed] = useState();

  const reviewDocument = (row) => {
    let documentsReviewedBy = row?.downloadedUsers;
    setDocumentsReviewed(documentsReviewedBy);
    const modalElement = document.getElementById("document-review-users");
    if (modalElement) {
      const modal = new Modal(modalElement);
      modal.show();
    }
  };

  const handleDocumentStatus = (e, row) => {
    debugger;
    dispatch(documentsActions.dcoumentStatusChange(row?._id))
      .then((result) => {
        if (result?.payload?.status === 1) {
          debugger;
          showToastNotification(result?.payload?.message, "success");
          let params = apiParams;
          if (params.includes("?")) {
            params = params.replace("?", "&");
          }
          dispatch(
            documentsActions.getAllDocumentSearch({
              id: committeeId,
              params: params,
            }),
          );
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to delete members", "error");
      });
  };

  const editDocument = (row) => {
    const docRow = {
      title: row?.title,
      committee: row?.committee?._id,
      category: row?.category?._id,
      file: row?.file,
      fileCheck: row?.file
        ? { name: row?.file, type: row?.type || "" }
        : undefined,
      id: row._id,
    };

    setCreateDoc(false);
    setUpdateFileName(row?.file);

    setEditRow(docRow);

    setIsEditMode(true);

    dispatch(documentsActions.updateDocumentForm(docRow));
  };

  const handleDelete = (row) => {
    Popup({
      title: "Message",
      text: `Are you sure you want to delete the document?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        // setEventID(row?._id);
        dispatch(documentsActions?.DeleteDocments(row?._id))
          .then((result) => {
            if (result?.payload?.status === 1) {
              setIsPending(false);
              showToastNotification(result?.payload?.message, "success");
              let params = apiParams;
              if (params.includes("?")) {
                params = params.replace("?", "&");
              }
              dispatch(
                documentsActions.getAllDocumentSearch({
                  id: committeeId,
                  params: params,
                }),
              );
            } else {
              showToastNotification(result?.error?.message, "error");
            }
          })
          .catch((err) => {
            showToastNotification("Failed to create member", "error");
          });
      },
    });
  };

  const handleRowPerPage = (page) => {
    debugger;
    const updatedParams = apiParams
      .replace(/&limit=\d+/, `&limit=${page}`)
      // .replace(/([?&])page=\d+/, `$1page=${1}`);
      .replace(/([?&])page=\d+/, `&page=${1}`);

    const updateIdIntoParams = `${committeeId + updatedParams}`;
    setApiParams(updatedParams);
    dispatch(documentsActions?.getAllDocuments(updateIdIntoParams));
    setRowCountPerPage(page);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    debugger;
    // const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `&page=${page}`);
    const updateIdIntoParams = `${committeeId + updatedParams}`;
    setApiParams(updatedParams);
    dispatch(documentsActions?.getAllDocuments(updateIdIntoParams));
    setPageNo(page);
  };

  const handleSearchChange = (e, name) => {
    let duplicate = { ...Filters };
    if (name === "status") {
      duplicate.status = e?.target?.value === "true" ? true : false;
    } else if (name === "category") {
      duplicate.category = e?.value || "";
    } else {
      duplicate.title = (e?.target?.value || "").trimStart();
    }
    SetFilters(duplicate);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    dispatch(
      documentsActions.getAllDocumentSearch({
        id: committeeId,
        params: apiParams,
      }),
    );
  };

  const handleSearchFormReset = (e) => {
    e.preventDefault();
    dispatch(documentsActions.getAllDocuments(committeeId));
    SetFilters({
      title: "",
      category: "",
      status: true,
    });
  };

  //Add Category
  const handleAddCategory = () => {
    setErrorMessage({});
    const modalElement = document.getElementById("document-add-category");
    if (modalElement) {
      const modal = new Modal(modalElement);
      modal.show();
    }
  };

  const { categoryForm, categoryByIdList } = useSelector((x) => x.category);

  const handleCategoryChange = (e, select) => {
    let form = { ...categoryForm };

    if (select) {
      form[select] = e?.value;
      dispatch(categoryActions.updateCategoryForm(form));
      return;
    }
    let { name, value } = e.target;

    form[name] = value;

    dispatch(categoryActions.updateCategoryForm(form));
  };

  const handleFormSubmit = (e) => {
    const formData = { ...categoryForm };
    formData["committee"] = committeeId;
    e?.preventDefault();
    setIsPending(true);
    setErrorMessage({});

    const { error } = categorySchema(formData);

    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    //API call after validation
    const resquest = dispatch(
      categoryActions.CreateCategory({
        committee: committeeId,
        title: categoryForm.title,
      }),
    );
    resquest
      .then((result) => {
        setIsPending(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          dispatch(categoryActions.resetCategoryForm());
          dispatch(categoryActions.getCategoryLabel(committeeId));
          handleFormReset();

          // setCreateCategory(false);
          // setIsEditMode(false);
          const modalElement = document.getElementById("document-add-category");
          if (modalElement) {
            const modal = Modal.getInstance(modalElement); // get current instance
            if (modal) modal.hide();
          }
          const docRow = {
            title: documentForm?.title,
            file: documentForm?.file,
            fileCheck: documentForm?.fileCheck,
          };
          dispatch(documentsActions.updateDocumentForm(docRow));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setIsPending(false);
      });
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">{committeeName}</h1>
        <div>
          {createDoc === false && (
            <Button
              className="me-2"
              label="Create"
              status="secondary"
              onClick={() => {
                setCreateDoc(true);
                setIsEditMode(false);
                setUpdateFileName("");
                dispatch(documentsActions.resetDocumentForm());
              }}
            />
          )}

          <Button
            label="Back"
            status="reset"
            onClick={() => {
              setErrorMessage({});
              isEditMode === false && createDoc === false
                ? history?.navigate("/Admin/CommitteePage")
                : setIsEditMode(false);
              setCreateDoc(false);
            }}
          />
        </div>
      </div>
      {isEditMode === false && createDoc === false && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
            Search Document
          </h1>

          <form
            className="p-3 row"
            onSubmit={(e) => {
              handleSearchSubmit(e);
            }}
            onReset={(e) => {
              handleSearchFormReset(e);
            }}
          >
            <div className="col-md-4">
              <TextInput
                label="File Name"
                placeholder="File Name"
                name="title"
                id="title"
                handleChange={(e) => handleSearchChange(e, "title")}
                value={Filters?.title}
              />
            </div>

            <div className="col-md-4">
              <SelectInput
                options={
                  Array.isArray(CategoryDropdownlist)
                    ? CategoryDropdownlist
                    : Object.values(CategoryDropdownlist || {})
                }
                label="Category"
                // label={
                //   <div className="d-flex align-items-center gap-2">
                //     <span>Category</span>
                //     <button
                //       type="button"
                //       onClick={handleAddCategory}
                //       className="quick-document-category"
                //     >
                //       +
                //     </button>
                //   </div>
                // }
                name="category"
                handleChange={(e) => handleSearchChange(e, "category")}
                value={Filters?.category}
              />
            </div>

            <div className="col-md-4">
              <RadioInput
                name="status"
                id="status"
                label="Status"
                options={ActiveStatus}
                handleChange={(e) => handleSearchChange(e, "status")}
                selectedValue={Filters?.status}
                value={Filters?.status}
              />
            </div>

            <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
              <Button status="secondary" label="Search" type="submit" />
              <Button status="reset" label="Reset" type="reset" />
            </div>
          </form>
        </div>
      )}

      {(isEditMode || createDoc) && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            {isEditMode ? "Edit" : "Create"} Document
          </h1>

          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
            className="p-3 row mb-4"
          >
            <div className="col-md-4">
              <TextInput
                name="title"
                id="title"
                label="File Name"
                placeholder="File Name"
                handleChange={(e) => {
                  handleChange(e, "title");
                }}
                required
                value={documentForm?.title}
                errorMessage={errorMessage}
              />
            </div>

            <div className="col-md-4" style={{ marginTop: "-6px" }}>
              <SelectInput
                options={
                  Array.isArray(CategoryDropdownlist)
                    ? CategoryDropdownlist
                    : Object.values(CategoryDropdownlist || {})
                }
                name="category"
                id="category"
                // label="Category"
                label={
                  <div className="d-flex align-items-center gap-2">
                    <label className="form-label col-form-label w-100 font-size-14 form-label-custom-visible p-0">
                      Category {<span className="text-danger">*</span>}
                      <button
                        type="button"
                        onClick={handleAddCategory}
                        className="quick-document-category"
                      >
                        +
                      </button>
                    </label>
                  </div>
                }
                handleChange={(e) => handleChange(e, "category")}
                // required
                value={documentForm?.category}
                errorMessage={errorMessage}
              />
            </div>

            <div className="col-md-4">
              <FileInput
                label="File"
                id="file"
                name="fileCheck"
                errorMessage={errorMessage}
                required
                handleFileChange={(e) => handleChange(e, "file")} //
                // imageURL={isEditMode ? fileUrl + documentForm?.file : ""}
              />
              <p className="text-gray fs-6">
                Supported File type : (PDF, DOC, DOCX, JPG, PNG, XLSX)
              </p>
              <p className="text-gray">{title}</p>
            </div>

            <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
              <Button
                label={isEditMode ? "Update" : "Add"}
                status="primary"
                type="submit"
                disabled={isPending}
              />
              <Button
                label="Reset"
                status="reset"
                type="reset"
                onClick={() => {
                  handleFormReset();
                }}
              />
            </div>
          </form>
        </div>
      )}

      {isEditMode === false && createDoc === false && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color p-3 ">Documents List</h1>

          <Table
            columns={columns}
            data={AlldocList?.documents}
            pagination
            onChangeRowsPerPage={handleRowPerPage}
            onChangePage={handlePageChange}
            totalRowCount={totalCount || 0}
            currentPage={pageNo}
            paginationPerPage={rowCountPerPage}
          />
        </div>
      )}
      <CommonModal
        modalId="document-review-users"
        title={"Documents Reviewed By"}
        bodyContent={
          <>
            {documentsReviewed?.length > 0 ? (
              <ol>
                {documentsReviewed.map((review, index) => (
                  <li key={index}>{review?.fullName}</li>
                ))}
              </ol>
            ) : (
              <p>No events found.</p>
            )}
          </>
        }
        footerContent={
          <div className="border-0 d-flex justify-content-between align-items-center w-100">
            <span>Total Count: {documentsReviewed?.length || 0}</span>
            <button className="btn btn-primary" data-bs-dismiss="modal">
              Close
            </button>
          </div>
        }
      />
      <CommonModal
        modalId="document-add-category"
        title="Create Document's Category"
        bodyContent={
          <>
            <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
              {/* <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
                 Create Category
              </h1> */}
              <form
                onSubmit={(e) => {
                  handleFormSubmit(e);
                }}
                onReset={(e) => {
                  handleFormReset(e);
                }}
                className="p-3 row"
              >
                <div className="row mb-4">
                  <div className="col-md-6">
                    <TextInput
                      label="Title"
                      placeholder="title"
                      name="title"
                      id="title"
                      handleChange={(e) => handleCategoryChange(e)}
                      required
                      errorMessage={errorMessage}
                      value={categoryForm?.title}
                    />
                  </div>
                  {/* {!isEditMode && (
             {!categoryId && (
              <div className="col-md-4">
                <SelectInput
                  options={getCommitteeListResponse?.data}
                  name="committee"
                  id="committee"
                  label="Committee"
                  required
                  handleChange={(e) => handleChange(e, "committee")}
                  errorMessage={errorMessage}
                  value={categoryForm?.committee}
                />
              </div>
            )} */}
                </div>
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <Button
                    label={"Submit"}
                    type="submit"
                    status="secondary"
                    disabled={isPending}
                  />
                  <Button label="Reset" type="reset" status="reset" />
                </div>
              </form>
            </div>
          </>
        }
        footerContent={
          <div className="border-0 d-flex justify-content-between align-items-center w-100">
            <button className="btn btn-primary" data-bs-dismiss="modal">
              Close
            </button>
          </div>
        }
      />
    </>
  );
}

export default CommitteeDocumentPage;
